var map = {
	"./_0-COVER-Boa.jpeg": 8715,
	"./_1-Boa.png": 9643,
	"./_10-COVER-Boa.png": 5465,
	"./_2-Boa_ske.png": 9495,
	"./_3-Boa.png": 1550,
	"./_4_ Lamp on table copy.jpg": 7607,
	"./_5_ Corte tecnico lampara copy.jpg": 6802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 726;